import React from 'react';
import styles from './SectionTasks.module.scss';
import TaskCard from '../../components/TaskCard/TaskCard';
import { useLanguage } from '../../contexts/LanguageContext';

export default function SectionTasks() {
    const { t, language } = useLanguage();
    
    // Массив с заданиями
    const tasks = [
        {
            id: 1,
            title: t('task.1.title'),
            description: t('task.1.description'),
            buttonText: t('task.1.button'),
            buttonLink: 'https://t.me/gramster_news',
            completed: true
        },
        {
            id: 2,
            title: t('task.2.title'),
            description: t('task.2.description'),
            buttonText: t('task.2.button'),
            buttonLink: 'https://t.me/gramster_updates',
            completed: false
        },
        {
            id: 3,
            title: t('task.3.title'),
            description: t('task.3.description'),
            buttonText: t('task.3.button'),
            buttonLink: 'https://t.me/gramster_support_bot',
            completed: false
        },
        {
            id: 4,
            title: t('task.4.title'),
            description: t('task.4.description'),
            buttonText: t('task.4.button'),
            buttonLink: 'https://t.me/gramster_examples',
            completed: false
        },
        {
            id: 5,
            title: t('task.5.title'),
            description: t('task.5.description'),
            buttonText: t('task.5.button'),
            buttonLink: 'https://t.me/gramster_partner',
            completed: false
        }
    ];

    return (
        <section className={styles["page__tasks"]}>
            <div className="page__tasks__container">
                <div className={styles.tasks__content}>
                    <h1 className={styles.tasks__title}>{t('tasks.title')}</h1>
                    <div className={styles.tasks__divider}></div>
                    
                    <div className={styles.tasks__list}>
                        {tasks.map(task => (
                            <TaskCard 
                                key={task.id}
                                title={task.title}
                                description={task.description}
                                buttonText={task.buttonText}
                                buttonLink={task.buttonLink}
                                completed={task.completed}
                                isPartner={task.id === 5}
                            />
                        ))}
                    </div>
                    
                    <div className={styles.tasks__bonus}>
                        <div className={styles.tasks__bonus_icon}>🎁</div>
                        <div className={styles.tasks__bonus_content}>
                            <h3 className={styles.tasks__bonus_title}>{t('tasks.reward.title')}</h3>
                            <div className={styles.tasks__bonus_main}>
                                <span className={styles.tasks__bonus_days}>{t('tasks.reward.days')}</span>
                                <span className={styles.tasks__bonus_text}>{t('tasks.reward.service')}</span>
                                <span className={styles.tasks__bonus_subtitle}>{t('tasks.reward.subtitle')}</span>
                            </div>
                            <div className={styles.tasks__bonus_partners}>
                                <span className={styles.tasks__bonus_partner_icon}>💜</span>
                                <span>{t('tasks.reward.partners')}</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className={styles.tasks__warning}>
                        <p>{t('tasks.warning')}</p>
                    </div>
                    
                    <div className={styles.tasks__bottom_spacer}></div>
                </div>
            </div>
        </section>
    );
} 